module.exports = __webpack_public_path__ + "img/widi-logo-xs.6ad0adb5.png";